module.exports = __webpack_public_path__ + "static/media/consent.06263aef.png";